import React from 'react';
import { cx } from '@emotion/css';
import { css } from '@emotion/react';

import { Typography } from '@common/styles';

import { InterestFree } from './InterestFree';

export const InterestFreeBottomInfo: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div
      css={css`
        margin: 8px 0 0;
        padding: 0 0 40px;
        .drawer-title {
          display: flex;
          align-items: center;
          height: 56px;
          padding: 0 16px;
        }
        .drawer-content-wrapper {
          height: 416px;
          overflow-y: auto;
          padding: 0 16px;
        }
      `}
    >
      <div className={cx('drawer-title', Typography.BODY_16_SEMIBOLD)}>{'무이자정보'}</div>
      <div className='drawer-content-wrapper'>
        <InterestFree />
      </div>
    </div>
  );
};
